import { buildAgentQuestionAnsweredBlocks } from './buildAgentQuestionAnsweredBlocks.js'

/**
 * @param {Record<string, unknown[]>} prev
 * @param {{ tid: string, assistantMessageId: string, selectedAnswer: string }} p
 */
export function markAgentQuestionAnswered(prev, { tid, assistantMessageId, selectedAnswer }) {
  const list = prev[tid]
  if (!list?.length) return prev
  const idx = list.findIndex((m) => m.id === assistantMessageId)
  if (idx === -1) return prev
  const msg = list[idx]
  const agentQuestion = msg.agentQuestion
  if (!agentQuestion || agentQuestion.status !== 'open') return prev

  const answeredQuestion = {
    ...agentQuestion,
    status: 'answered',
    selectedAnswer,
  }
  const priorBlocks = Array.isArray(msg.blocks) ? msg.blocks : []
  const answerBlocks = buildAgentQuestionAnsweredBlocks(
    agentQuestion.prompt,
    selectedAnswer,
    agentQuestion.kind,
  )
  const replyBlocks = answerBlocks.filter((block) => block.variant === 'muted' && block.content)
  const blocks =
    priorBlocks.length > 0
      ? replyBlocks.length > 0
        ? [...priorBlocks, ...replyBlocks]
        : priorBlocks
      : answerBlocks

  const next = [...list]
  next[idx] = {
    ...msg,
    agentQuestion: answeredQuestion,
    blocks,
    text: priorBlocks.length > 0 ? msg.text : agentQuestion.prompt,
  }
  return { ...prev, [tid]: next }
}
